/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Staff_Resellers_List_TitleInputs */

const id_staff_resellers_list_title = /** @type {(inputs: Staff_Resellers_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua reseller`)
};

const en_staff_resellers_list_title = /** @type {(inputs: Staff_Resellers_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All resellers`)
};

/**
* | output |
* | --- |
* | "All resellers" |
*
* @param {Staff_Resellers_List_TitleInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const staff_resellers_list_title = /** @type {((inputs?: Staff_Resellers_List_TitleInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Staff_Resellers_List_TitleInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_staff_resellers_list_title(inputs)
	return id_staff_resellers_list_title(inputs)
});